import api from './api';
import { clearBookmarksCache } from '../utils/bookmarks';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', credentials);
    return response.data;
  },

  async logout(): Promise<void> {
    await api.delete('/auth/logout');
    localStorage.removeItem('access_token');
    clearBookmarksCache(); // Clear bookmarks cache on logout
  },

  async validateSession(): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/validate-session');
    return response.data;
  },

  getToken(): string | null {
    return localStorage.getItem('access_token');
  },

  setToken(token: string): void {
    localStorage.setItem('access_token', token);
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};

